import React from 'react';
import { formatCurrency } from '../../../utils/formatters';
import './WalletCard.css';

/**
 * WalletCard - Tarjeta para mostrar información de wallet
 */
const WalletCard = ({ 
  type, 
  title,
  subtitle,
  balance, 
  assets, 
  stats,
  onViewDetails,
  className = ''
}) => {
  const getTypeClass = () => {
    switch(type) {
      case 'spot': return 'wallet-spot';
      case 'futures': return 'wallet-futures';
      case 'solana': return 'wallet-solana';
      default: return '';
    }
  };

  const getIcon = () => {
    switch(type) {
      case 'spot': return '🟠';
      case 'futures': return '🔵';
      case 'solana': return '🟢';
      default: return '💰';
    }
  };

  return (
    <div className={`wallet-card ${getTypeClass()} ${className}`}>
      <div className="wallet-header">
        <div className="wallet-icon">{getIcon()}</div>
        <div className="wallet-info">
          <h3 className="wallet-title">{title}</h3>
          <p className="wallet-subtitle">{subtitle}</p>
        </div>
      </div>

      <div className="wallet-balance">
        {formatCurrency(balance)}
      </div>

      {stats && stats.length > 0 && (
        <div className="wallet-stats">
          {stats.map((stat, idx) => (
            <div key={idx} className="stat-row">
              <span className="stat-label">{stat.label}:</span>
              <span className={`stat-value ${stat.className || ''}`}>
                {stat.value}
              </span>
            </div>
          ))}
        </div>
      )}

      {assets && assets.length > 0 && (
        <div className="wallet-assets">
          {assets.map((asset, idx) => {
            const symbol = asset.symbol || asset.asset;
            const isStablecoin = ['USDT', 'USDC', 'BUSD', 'FDUSD', 'DAI'].includes(symbol);
            const isUsd = asset.isUsd || isStablecoin;
            
            return (
              <div key={idx} className="asset-row">
                <span className="asset-name">{symbol}</span>
                <span className="asset-amount">
                  {typeof asset.amount === 'number'
                    ? (isUsd
                        ? formatCurrency(asset.amount)
                        : asset.amount.toFixed(asset.decimals || 4))
                    : asset.amount}
                </span>
              </div>
            );
          })}
        </div>
      )}

      {onViewDetails && (
        <button className="btn-view-details" onClick={onViewDetails}>
          View Details →
        </button>
      )}
    </div>
  );
};

export default WalletCard;
